import { QueryKey } from 'react-query';
import { getUser } from '@frontend/auth-helpers';
import { getArrayWithNonEmptyValues } from '../use-memoized-array';

/**
 * This hook returns a function that generates a multi-query key based on the passed in location IDs and user ID.
 */
export const useMultiQueryKey = (locationIds: (string | undefined) | (string | undefined)[]) => {
  const { userID } = getUser() ?? {};
  locationIds = getArrayWithNonEmptyValues(locationIds);

  const getMultiQueryKey = (queryKey: QueryKey) => {
    if (!Array.isArray(queryKey)) queryKey = [queryKey];
    return [...locationIds, userID, ...queryKey];
  };

  return {
    getMultiQueryKey,
  };
};
